export default __webpack_public_path__ + "static/media/480_business06-fr-web.d2c01f08.png";